
// バックエンドからの変数はnotify_count,notify_dataに保持しています。
// ユーザー名とチーム名はJetstreamのテーブルの値を使用しています。

<template>
  <!-- gnav: GlovalNAVication 全ページに共通のナビゲーションヘッダ -->
  <nav class="gnav">
    <!-- gnav左寄せの内容 -->
    <div class='left-item-group'>

      <!-- メニュー表示用ボタン -->
      <input id="menu__toggle" type="checkbox" @click="on_sidebar" />
      <label class="menu__hamburger-btn" for="menu__toggle">
        <img class="menu__hamburger-icon" src="/img/04_hamburger.svg"/>
      </label>

      <!-- サイドバー表示時のオーバーレイ -->
      <label class="overlay"  for="menu__toggle"></label>

      <!-- サイドバー -->
      <ul class="sidebar" v-bind:class="{mv_r : is_sidebar}">
        <li><Link class="sidebar__item" :href="route('clients.index')"> クライアント管理 </Link></li>
        <li><Link class="sidebar__item" :href="route('messages.index')"> 通知管理 </Link></li>
        <li><Link class="sidebar__item" :href="route('inquiries.index')"> お問合せ管理 </Link></li>
      </ul>

      <!-- JVTAのロゴ: クライアント一覧へ繊維 -->
      <Link :href="route('clients.index')">
        <img src="/img/04_Subit_logo_B.png" alt="logo_menu" class="logo" style="width: 7rem" />
      </Link>

    </div>

    <!-- gnav右寄せの内容 -->
    <div class='right-item-group'>
      <!--ログアウトボタン -->
      <button class="logout__btn" @click="logout">
        <img class="logout__svg" src="/img/04_logout.svg" alt="logout_menu"/>
      </button>
    </div>
  </nav>
</template>

<script>
import { Link } from '@inertiajs/inertia-vue3';
import { defineComponent } from 'vue';
import JetDropdown from '@/Jetstream/Dropdown.vue';
import JetDropdownLink from '@/Jetstream/DropdownLink.vue';
import JetNavLink from '@/Jetstream/NavLink.vue';
import modal from "@/Pages/Components/modal.vue";

export default defineComponent({
  components: {
    Link,
    modal, 
    JetDropdown,
    JetDropdownLink,
    JetNavLink,
  },
  data() {
    return {
      selectedMessages: [],
      openedMessage: Object, //詳細モーダルで表示するメッセージ
      is_sidebar: false
    };
  },
  computed: {
    notify_counter() {
      return {
        '--notify_count': this.notify_count,
      };
    },
  },
  methods: {
    
    showProps(){
      console.log(this.props);
    },
    switchTeam(team) {
      this.$inertia.put(
        route('current-team.update'),
        {team_id: team.id},
        {preserveState: false}
      );
    },
    on_sidebar(){
      if(this.is_sidebar){
        this.is_sidebar=false
      }else{
        this.is_sidebar=true
      }
    },
    logout() {
      if (confirm('ログアウトします。よろしいですか？')){
        this.$inertia.post(route('admin.destroy'));
      }
    },
    openNotificationIndexModal(){
      this.$refs.notificationIndexModal.openModal({is_wide: true, is_long: true});
    },
    openNotificationDetailModal(message){
      this.openedMessage = message;
      this.$refs.notificationIndexModal.closeModal();
      this.$refs.notificationDetailModal.openModal({is_wide: true});      
    },
    leaveNotificationDetailModal(){
      this.$refs.notificationDetailModal.closeModal();
      this.$refs.notificationIndexModal.openModal({is_wide: true, is_long: true});
    }
  },
  mounted: function(){
    window.addEventListener('mouseup', function(event){

      // ドロップダウンリストの外を押されたときに、閉じる
      // あまり良くない実装なので、時間があれば修正する
      var teamDropList = document.getElementById('dropdown__list--team');
      var teamDropToggle = document.getElementById('dropdown-toggle--team');
      var teamDropBtn = document.getElementById('dropdown-btn--team');
      if (event.target != teamDropList
        && event.target.parentNode != teamDropList
        && event.target !=teamDropBtn 
        && event.target.parentNode !=teamDropBtn
      ){
        // document.getElementById('dropdown-toggle--team').checked = false;
      }

      var userDropList = document.getElementById('dropdown__list--user');
      var userDropToggle = document.getElementById('dropdown-toggle--user');
      var userDropBtn = document.getElementById('dropdown-btn--user');
      if (event.target != userDropList
        && event.target.parentNode != userDropList
        && event.target !=userDropBtn 
        && event.target.parentNode !=userDropBtn
      ){
        // document.getElementById('dropdown-toggle--user').checked = false;
      }
    });
  },
});
</script>

<style lang="scss" scoped>
$modal_bg: #fffbf9;
$over_modal_bg: #999999;
$table_cel_font: #666666;
$menu_bg: #31343d;
$menu_font_color: #dcdcdc;
$dropdown_bg: #fffbf9;

// メニューバーの表示に関するスタイル
.gnav {
  z-index:3;

  box-shadow: 2px 2px 6px rgba(0, 0, 0, .4);
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.5rem 1rem;
  background-color: #31343d;
  position:fixed;
  top:0;
  width: 100%;
}

// メニューバーの左側のアイテム（メニューアイコン、JVTAロゴ）
.left-item-group {
  display: flex;
  justify-content: start;
  align-items: center;
}

// メニューボタンの表示に関する要素
#menu__toggle{display: none;}
// #menu__toggle:checked ~ .sidebar {
//   left: 0 !important;
// }
.mv_r {
  left: 0 !important;
}
#menu__toggle:checked ~ .overlay {
  visibility: visible;
  opacity: 1;
}
.menu__hamburger-btn {
  cursor: pointer;
  z-index: 3;
}
.menu__hamburger-icon {
  padding: 0 0.5rem 0 0;
  height: 2.5rem;
}

.overlay{
	z-index:1;
	display:block;
  visibility: hidden;
  opacity: 0;
	position:fixed;
	width:100%;
	height:120%;
	top:4rem;
	left:0;
	background-color:rgba(0,0,0,0.75);
  transition: .25s;
}

// サイドバーに関するスタイル
.sidebar {
  z-index: 2;
  display: block;
  position: fixed;
  top: 4rem;
  left: -100%;
  width: 250px;
  height: 100%;
  margin: 0;
  padding: 2rem 0;
  list-style: none;
  box-shadow: 2px 2px 6px rgba(0, 0, 0, .4);
  transition-duration: .25s;
  // background-color: #ECEFF1;
  background-color: #31343d;
  hr{color: #949494}
}
.sidebar__item {
  display: block;
  padding: 12px 24px;
  color: white;
  text-decoration: none;
}
.sidebar__item--head {
  font-size: small;
  display: block;
  padding: 6px 24px;
  color: #949494;
  text-decoration: none;
  transition-duration: .25s;
}

.sidebar__item:hover {
  background-color: #202225;
}

.jvta-logo{
  fill: #dcdcdc;
  height: 3rem;
  width: 6rem;
}

// メニューバーの右側のアイテム（現在のチーム名、ユーザ名、通知アイコン、設定アイコン、ログアウトボタン）
.right-item-group {
  display: flex;
  justify-content: end;
  align-items: center;
}

// ドロップダウン
.dropdown {
  height: 2rem;
  margin: 0 0.5rem;
  position: relative;
  transition: all .3s;
}
// ドロップダウンボタン
.dropdown__btn{
  display: flex;
  align-items: center;
  text-align: center;
  justify-content: space-between;

  font-size: 1rem;
  height: 2rem;
  // width: 10rem;
  cursor: pointer;
  color: white;
  border: solid $menu_font_color 1px;
  background: $menu_bg;
  border-radius: 100vh;
  color: $menu_font_color;
  vertical-align: middle;
}
.dropdown__btn:hover {
    background-color: #202225;
}
.dropdown__btn-text{
  padding: 0 1rem;
}
.dropdown__btn-vdots{
  fill: #dcdcdc;
  height: 1rem;
  width: 2rem;
}

#dropdown-toggle--team{display: none;}
#dropdown-toggle--team:checked ~ #dropdown__list--team {
  visibility: visible;
  opacity: 1;
}
#dropdown-toggle--user{display: none;}
#dropdown-toggle--user:checked ~ #dropdown__list--user {
  visibility: visible;
  opacity: 1;
}

// リストの書式
.dropdown__list {
  z-index: 1;
  box-shadow: 2px 2px 6px rgba(0, 0, 0, .4);
  // default: 非表示
  visibility: hidden; 
  opacity: 0;
  transition: all .25s;  width: 100%;
  list-style: none;
  position: relative;
  top: 0.5rem;
  margin:0;
  padding:0;
  background-color: #31343d;
  hr{
    color: #949494;
    margin: 0.5rem 0;
  }
}

.dropdown__item {
  cursor: pointer;
  display: block;
  height: 2rem;
  padding: 0 0 0 1rem;

  display: flex;
  align-items: center;
  text-align: center;
  
  text-decoration: none;
  color: white;

  transition-duration: .25s;
  position: relative;
}

.dropdown__item:hover {
  background-color: #202225;
}

.dropdown__item--head {
  font-size: small;
  color: #949494;
  display: block;
  height: 2rem;
  padding: 0 0 0 1rem;

  display: flex;
  align-items: center;
  text-align: center;
  
  text-decoration: none;
  transition-duration: .1s;
  position: relative;
}

// 通知アイコン
.notif__btn{
  border: none;
  background: transparent;
}
.notif__icon{
  height: 2rem;
  position: relative;
  left:0.5rem;
}
.notif__icon--no-unread{
  height: 2rem;
  margin:0 1rem;
}
.notif__icon-badge{
  padding:2px 3px;
  background-color: red;
  font-size: 12px;
  color: white;
  text-align: center;
  border: solid;
  border-radius: 100vh;
  border-color: #31343d;
  position: relative;
  right:0.5rem;
  top:-0.5rem;
}

// 設定アイコン
.setting__icon{
  height: 2rem;
}

// ログアウトボタン
.logout__btn{
  margin: 0 0 0 1rem;
  border: none;
  background: transparent;
}
.logout__svg{
  height: 2rem;
}

// #[Modal Window]#############################################################//
// .notif-idx-mdl{
//   width: 75%;
// }
.notif-table-head{
  margin: 1rem 0;
  text-align: end;
}
.notif-table{
  width: 100%;
  table-layout: fixed;
  overflow-wrap: break-word;
  word-wrap: break-word;
}
// .notif-table__th--contents{
//   width: 70%
// }
.notif-table__th--date{
  width: 7rem;
}
.notif-table__th--checkbox{
  width: 2rem;
}

.notif-table__td--contents{
  cursor: pointer;
  text-align:left;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  span{padding: 0 0.5rem}
}

.contents-td__tag--unread {
  background-color: #9966cc;
  color: white;
  font-weight: normal;
  padding: 2px 4px;
  margin-right: 3px;
}

.contents-td__tag--important {
  background-color: #ff6666;
  color: white;
  font-weight: normal;
  padding: 2px 3px;
  margin-right: 3px;
}


.notif-table-foot{
  margin: 1rem 0;
  text-align: end;
}

//# [通知詳細モーダル] ####################################################################//
.msg-group{
  padding: 0 2rem;
}
.msg__section{
  margin: 1rem 0;
  text-align: start;
}

.msg__panel {
  height: 40vh;
  overflow-y: scroll;
  width: 100%;
  padding: 1rem;
  // margin: auto;
  overflow-wrap: break-word;
  border: 1px solid;
  border-radius: 10px;
  // padding-left: 15px;
  // padding-right: 15px;
  color: #666666;
  background-color: #ffffff;
  // white-space: nowrap; /*　（全角+半角）の文字で改行しないように */
}

.msg__foot{
  margin: 1rem 0;
  text-align: center;
}

</style>